<!--
     <SimpleColorPicker
       ref='colorpicker'
       :value='my_value'
       disabled
     >

       OPTIONAL TEMPLATE:
       <template v-slot="activator" v-on="on" color="color">
         <v-btn v-on="on" :background='color'>{{ color }}</btn>
       </template>

     </SimpleColorPicker>

     Public methods:
     lauch() → Async method that returns the boolean answer
-->

<template>
  <div class="s">
    <v-menu
      offset-y
      width="600px"
      :disabled="disabled"
    >
      <template v-slot:activator="{ on, attrs }">
        <slot name="activator" :color="color">
          <v-btn :color="color" v-on="on" :depressed="disabled">Color</v-btn>
        </slot>
      </template>
        
      <v-card class="elevated-1">
        <div class="scp-gird">
          <div class="scp-row" v-for="row of preset">
            <button
              class="scp-box"
              v-for="col of row"
              :title="col"
              :style="'background-color:'+col"
              @click="select_color(col)"
            ></button>
          </div>
        </div>
      </v-card>
    </v-menu>
  </div>
</template>

<style lang="scss">
 .scp-gird {
   display: flex;
   flex-direction: column;
   flex-wrap: wrap;
   max-width: 520px;
   max-height: 480px;
   overflow-x: scroll;
   padding: 4px;
 }

 .scp-row {
   display: flex;
   flex-direction: row;
 }

 .scp-box {
   width: 32px;
   height: 32px;
   border-style: solid;
   border-with: 2px;
   border-color: #ffffff;
   border-radius: 5px;
 }

 .scp-box:hover {
   border-color: #000000;
   box-shadow: 0 0 2px #acacac;
 }
</style>


<script>
 export default {
   name: "SimpleColorPicker",

   props: {
     value: {},
     disabled: {'default': false},
   },

   data: () => ({
     color: '#00ff00',
     preset: [
       ["#faa","#fda","#ffa","#dfa","#afa","#afd","#aff","#adf","#aaf","#daf","#faf","#fad","#fff"],
       ["#f55","#fa5","#ff5","#af5","#5f5","#5fa","#5ff","#5af","#55f","#a5f","#f5f","#f5a","#aaa"],
       ["#f00","#f80","#ff0","#8f0","#0f0","#0f8","#0ff","#08f","#00f","#80f","#f0f","#f08","#888"],
       ["#a00","#a50","#aa0","#5a0","#0a0","#0a5","#0aa","#05a","#00a","#50a","#a0a","#a05","#444"],
       ["#500","#520","#550","#250","#050","#052","#055","#025","#005","#205","#505","#502","#000"],
     ]
   }),

   mounted() {
     this.color = this.value || '#ffffff';
   },

   methods: {
     select_color(col) {
       this.color = col;
       this.update(this.color);
     },

     get_color() {
       return this.color;
     },

     update(color) {
       this.$emit('update', color);
     }
   },

   watch: {
     value(val) {
       this.color = val;
     },
   },
 }
</script>
